export const IconThumbsDownOutline = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4465 10.3828H15.4465V1.38279H12.4465V10.3828Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.446 2.38592C9.4116 2.38592 9.16437 1.17758 5.0559 0.930784C3.90237 0.861518 3.07457 0.801785 2.3063 1.78679C0.619105
    3.95005 -0.191295 9.09452 1.44517 9.09452H4.78797C5.5243 9.09452 6.1213 9.69149 6.1213 10.4279V13.0212C6.1213 15.0345 9.06657
    16.0911 9.06657 13.8345C9.06657 12.2161 9.68324 11.1036 10.7134 10.1235C11.2173 9.64406 11.8065 9.38741 12.446 9.25032"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
